import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a62b23f99f1da00148570d5_1784897994170_154539c4/novainvoice/src/app/page.tsx");
